export enum Theme {
  light = "LIGHT",
  dark = "DARK",
  system = "SYSTEM",
}
